<template>
  <v-container fluid>
    <v-row>
      <v-col class="custom-content-container pt-0" cols="12" md="9" sm="9">
        <v-row>
          <v-col md="12">
            <v-row>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Salutation</label
                  >
                  <v-select
                    :menu-props="{ offsetY: true }"
                    v-model.trim="personalInfo.title"
                    :items="salutationList"
                    dense
                    filled
                    :rules="[
                      validateRules.required(personalInfo.title, 'Title'),
                    ]"
                    item-text="text"
                    item-value="value"
                    item-color="cyan"
                    placeholder="Salutation"
                    solo
                    flat
                    color="cyan"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >First name</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.first_name"
                    :rules="[
                      validateRules.required(
                        personalInfo.first_name,
                        'First name'
                      ),
                      validateRules.minLength(
                        personalInfo.first_name,
                        'First name',
                        2
                      ),
                      validateRules.maxLength(
                        personalInfo.first_name,
                        'First name',
                        50
                      ),
                      validateRules.validPersonName(
                        personalInfo.first_name,
                        'First name'
                      ),
                    ]"
                    :maxlength="50"
                    dense
                    filled
                    placeholder="First name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16">Last name</label>
                  <v-text-field
                    v-model.trim="personalInfo.last_name"
                    :rules="[
                      validateRules.minLength(
                        personalInfo.last_name,
                        'Last name',
                        2
                      ),
                      validateRules.maxLength(
                        personalInfo.last_name,
                        'Last name',
                        50
                      ),
                      validateRules.validPersonName(
                        personalInfo.last_name,
                        'Last name'
                      ),
                    ]"
                    :maxlength="49"
                    dense
                    filled
                    placeholder="Last name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Display name</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.display_name"
                    :rules="[
                      validateRules.required(
                        personalInfo.display_name,
                        'Display name'
                      ),
                      validateRules.minLength(
                        personalInfo.display_name,
                        'Display name',
                        2
                      ),
                      validateRules.maxLength(
                        personalInfo.display_name,
                        'Display name',
                        120
                      ),
                      validateRules.validPersonName(
                        personalInfo.display_name,
                        'Display name'
                      ),
                    ]"
                    :maxlength="120"
                    dense
                    filled
                    placeholder="Display name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>

              <v-col md="4" class="py-1" v-if="false">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Skills</label
                  >
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="engineerSkills"
                    v-model.trim="personalInfo.skills"
                    :rules="[
                      validateRules.required(personalInfo.skills, 'Skills'),
                    ]"
                    dense
                    filled
                    placeholder="Skills"
                    solo
                    flat
                    item-color="cyan"
                    item-text="title"
                    item-value="value"
                    multiple
                  ></v-select>
                </template>
              </v-col>
              <v-col :md="allowZones ? 4 : 12" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Email address</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.primary_email"
                    :rules="[
                      validateRules.required(
                        personalInfo.primary_email,
                        'Email address'
                      ),
                      validateRules.validEmail(
                        personalInfo.primary_email,
                        'Email address'
                      ),
                      validateRules.minLength(
                        personalInfo.primary_email,
                        'Email address',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.primary_email,
                        'Email address',
                        50
                      ),
                    ]"
                    :maxlength="50"
                    dense
                    filled
                    placeholder="Email address"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <label class="font-weight-500 font-size-16 required">
                  Zone/Location of Operation</label
                >

                <v-autocomplete
                  class="small-chip-autocomplete"
                  :items="zoneList"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  solo
                  flat
                  multiple
                  v-model.trim="personalInfo.zone_territory"
                  placeholder="Select Zone"
                  item-text="name"
                  item-value="name"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Zone(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Phone number</label
                  >
                  <PhoneTextField
                    id="primary_phone"
                    v-model="personalInfo.primary_phone"
                    :value="personalInfo.primary_phone"
                    required
                  >
                  </PhoneTextField>
                </template>
              </v-col>
              <v-col md="4" class="py-1" v-if="false">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Role</label
                  >

                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="roles"
                    v-model.trim="personalInfo.role"
                    :rules="[validateRules.required(personalInfo.role, 'Role')]"
                    dense
                    filled
                    placeholder="Role"
                    solo
                    flat
                    item-color="cyan"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16"
                    >Employee Code</label
                  >
                  <TextField
                    id="employee_code"
                    dense
                    filled
                    solo
                    flat
                    placeholder="Enter employee code"
                    counter="20"
                    v-model="personalInfo.employee_code"
                    color="cyan"
                    :maxlength="20"
                  />
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required">
                    Department/ Business Unit</label
                  >
                  <v-autocomplete
                    :items="engineerDepartments"
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    solo
                    flat
                    v-model.trim="personalInfo.department"
                    append-outer-icon="mdi-cog"
                    placeholder="Select Department"
                    v-on:click:append-outer="Departmentdata"
                    item-text="text"
                    item-value="value"
                    class="width-100 new-height"
                    hide-details
                    :rules="[
                      validateRules.required(
                        personalInfo.department,
                        'Departmentdata'
                      ),
                    ]"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Department(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <!-- <template>
                    <ManageDepartment
                      :d-dialog="manageDepartmentDialog"
                      :e_department="engineerDepartments"
                      v-on:close-dialog="manageDepartmentDialog = false"
                      :exist-category="personalInfo.department"
                      v-on:get-e-department="getOptions"
                    ></ManageDepartment>
                  </template> -->

                  <Manage-Motor-Settings
                    :mDialog="manageSbuDialog"
                    :settings="sbuList"
                    title="SBU"
                    endpoint="setting/sbu"
                    value="sbu"
                    @close-dialog="manageSbuDialog = false"
                    @get-settings="getSbuList"
                  />
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required">
                    Designation</label
                  >
                  <v-autocomplete
                    :items="engineerDesignations"
                    dense.
                    filled
                    color="cyan"
                    item-color="cyan"
                    solo
                    flat
                    v-model.trim="personalInfo.designation"
                    append-outer-icon="mdi-cog"
                    placeholder="Select Designation"
                    v-on:click:append-outer="Designationdata"
                    item-text="text"
                    item-value="value"
                    class="width-100 new-height"
                    hide-details
                    :rules="[
                      validateRules.required(
                        personalInfo.designation,
                        'Designationdata'
                      ),
                    ]"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Designation(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <template>
                    <ManageEdesignation
                      :d-dialog="manageBrandDialog"
                      :e_designation="engineerDesignations"
                      v-on:close-dialog="manageBrandDialog = false"
                      :exist-category="personalInfo.designation"
                      v-on:get-e-designation="getOptions"
                    ></ManageEdesignation>
                  </template>

                  <!-- <v-select
                    :items="engineerDesignations"
                    v-model.trim="personalInfo.designation"
                    :rules="[
                      validateRules.required(
                        personalInfo.designation,
                        'Designation'
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Select Designation"
                    solo
                    flat
                    item-color="cyan"
                    item-text="title"
                    item-value="value"
                  ></v-select> -->
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16 required"
                    >Engineer Shift
                  </label>
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="shifts"
                    v-model.trim="personalInfo.shift"
                    dense
                    filled
                    placeholder="Engineer Shift"
                    solo
                    flat
                    item-color="cyan"
                    item-text="text"
                    item-value="value"
                    :rules="[
                      validateRules.required(
                        personalInfo.shift,
                        'Engineer Shift'
                      ),
                    ]"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  ></v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16">Is Team ?</label>
                  <v-switch
                    v-model="personalInfo.is_team"
                    inset
                    color="cyan"
                    hide-details
                    class="mt-0"
                  ></v-switch>
                </template>
              </v-col>
              <!-- <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16"
                    >OT 1.5 Date</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.ot_15_date"
                    type="number"
                    dense
                    filled
                    placeholder="OT 1.5 Date"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16">OT 2 Date</label>
                  <v-text-field
                    v-model.trim="personalInfo.ot_2_date"
                    type="number"
                    dense
                    filled
                    placeholder="OT 1.5 Date"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col> -->
            </v-row>
            <v-card class="py-3 px-4 rounded-lg mt-3" outlined>
              <div class="text-h6 font-weight-500 mb-0">Probation Info</div>
              <v-row>
                <v-col md="4" class="py-1">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16"
                      >Probation Period
                    </label>
                    <v-select
                      :menu-props="{ offsetY: true }"
                      :items="months"
                      v-model.trim="personalInfo.probation_month_number"
                      dense
                      filled
                      placeholder="Probation Month"
                      solo
                      v-on:change="setProbationTime"
                      flat
                      item-color="cyan"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </template>
                </v-col>
                <v-col md="4" class="py-1" v-if="false">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16">Type</label>
                    <v-select
                      :menu-props="{ offsetY: true }"
                      :items="types"
                      v-model.trim="personalInfo.probation_type"
                      dense
                      filled
                      placeholder="Type"
                      solo
                      flat
                      v-on:change="setProbationTime"
                      item-color="cyan"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </template>
                </v-col>
                <v-col md="4" class="py-1">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16"
                      >Probation Start</label
                    >
                    <DatePicker
                      placeholder="Probation Start Date"
                      v-model="personalInfo.probation_start"
                      v-on:change="setProbationTime"
                    />
                  </template>
                </v-col>
                <v-col md="4" class="py-1">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16"
                      >Probation End</label
                    >
                    <div
                      class="font-weight-700"
                      v-if="personalInfo.probation_end"
                    >
                      {{ formatDate(personalInfo.probation_end) }}
                    </div>
                    <div v-else>
                      <em class="text--secondary">No date available</em>
                    </div>
                    <!-- <DatePicker
                    :minDate="personalInfo.probation_start"
                    placeholder="Probation End Date"
                    v-model="personalInfo.probation_end"
                  /> -->
                  </template>
                </v-col>

                <!-- start addding new fields -->
                <!-- <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16">FIN No</label>
                  <v-text-field
                    v-model="personalInfo.fin_no"
                    dense
                    filled
                    placeholder="FIN No"
                    solo
                    flat
                    type="text"
                  ></v-text-field>
                  <DatePicker
                    placeholder="Probation Start Date"
                    v-model="personalInfo.probation_start"
                    v-on:change="setProbationTime"
                  />
                </template>
              </v-col> -->

                <!-- <v-col md="4" class="py-1">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-500 font-size-16"
                    >WP Expired Date</label
                  >
                  <DatePicker
                    placeholder="WP Expired Date"
                    v-model="personalInfo.wp_expired_date"
                    v-on:change="setWpExipryDate"
                  />
                </template>
              </v-col> -->

                <v-col md="4" class="py-1" v-if="false">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16"
                      >Vehicle No.</label
                    >
                    <v-text-field
                      v-model="personalInfo.vehicle_no"
                      dense
                      filled
                      placeholder="Vehicle No."
                      solo
                      flat
                      type="text"
                    ></v-text-field>
                  </template>
                </v-col>

                <v-col md="4" class="py-1" v-if="false">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16">IU No.</label>
                    <v-text-field
                      v-model="personalInfo.iu_no"
                      dense
                      filled
                      placeholder="IU No."
                      solo
                      flat
                      type="text"
                    ></v-text-field>
                  </template>
                </v-col>
                <!-- end addding new fields -->
              </v-row>
            </v-card>
            <v-row v-if="false">
              <v-col md="6" class="py-1">
                <div class="text-h6 font-weight-700 my-2">
                  Default Retention period
                </div>
                <div class="ps-6">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-500 font-size-16"
                      >Retention Period:</label
                    >
                    <v-row>
                      <v-col md="3" class="py-1">
                        <v-text-field
                          v-model="personalInfo.retention_period"
                          dense
                          filled
                          placeholder="Retention Period"
                          solo
                          flat
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4" class="pt-0">
                        <v-text-field
                          v-model="personalInfo.period"
                          dense
                          filled
                          placeholder="Days"
                          type="text"
                          solo
                          flat
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <div class="d-flex align-center w-75">
                      <label class="font-weight-500 font-size-16 me-15"
                        >Automatic Deletion Period:</label
                      >
                      <v-spacer></v-spacer>
                      <v-checkbox
                        class="mt-0 me-15 pe-11"
                        color="blue"
                        readonly
                        hide-details
                        v-model.trim="personalInfo.automatic_deletion_period"
                      />
                      <!-- <v-chip class="ms-15" outlined color="grey">
                        <v-icon class="me-2" color="blue" size="20"
                          >mdi-circle</v-icon
                        >
                        <span class="font-weight-500 font-size-16">ON</span>
                      </v-chip> -->
                    </div>
                    <v-row>
                      <v-col md="3">
                        <v-text-field
                          v-model="personalInfo.deletion_period"
                          dense
                          filled
                          placeholder="Deletion Period"
                          solo
                          flat
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field
                          v-model="personalInfo.period"
                          dense
                          filled
                          placeholder="Days"
                          type="text"
                          solo
                          flat
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0 && false">
              <v-col md="6" class="py-0 mt-2 mb-2">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    color="blue"
                    :readonly="true"
                    :label="getLabel()"
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.email_notification"
                  />
                  <!-- <v-switch
                    v-else
                    v-model.trim="personalInfo.email_notification"
                    inset
                    :value="1"
                    color="red"
                    hide-details
                    label="Activation email will be sent to the user"
                    class="mt-0"
                  ></v-switch> -->
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0 && false">
              <v-col md="4" class="py-1">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    v-if="false"
                    color="blue"
                    label="
                      Force user to change password on first log in
                    "
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.force_password_change"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0 && false">
              <v-col md="6" class="py-1">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    color="blue"
                    label="
                      Default Retention period
                    "
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.default_retention_period"
                  />
                </div>
              </v-col>
            </v-row>
            <v-card class="py-3 px-4 rounded-lg mt-4" outlined>
              <div class="text-h6 font-weight-500 mb-0">
                System Access Permissions
              </div>
              <p class="">Configure user access rights and security settings</p>
              <v-row class="align-items-center">
                <v-col cols="12" md="4" class="py-1">
                  <!-- Allow Login -->
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    ></v-skeleton-loader>
                  </template>
                  <v-switch
                    v-model.trim="personalInfo.can_login"
                    inset
                    :value="1"
                    color="cyan"
                    hide-details
                    label="Allow Login"
                    class="mt-0 mr-4"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="4" class="py-1">
                  <!-- OT Eligible -->
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    ></v-skeleton-loader>
                  </template>
                  <v-switch
                    v-model.trim="personalInfo.ot_eligible"
                    inset
                    :value="1"
                    color="cyan"
                    hide-details
                    label="OT Eligible"
                    class="mt-0 mr-4"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="4" class="py-1">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <v-switch
                    v-model.trim="personalInfo.is_tracking_enabled"
                    inset
                    :value="0"
                    color="cyan"
                    hide-details
                    label="Track Employee"
                    class="mt-0"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-card>
            <!-- Geo-Fencing Settings Section -->
            <v-card outlined class="px-3 rounded-lg mt-4" v-if="false">
              <div class="pt-4 px-4">
                <div class="text-h6 font-weight-500 mb-1">
                  <v-icon class="mr-2">mdi-map-marker</v-icon>
                  Geo-Fencing Setting
                </div>
                <p class="mb-0">
                  Configure location-based access controls and radius
                  enforcement
                </p>
              </div>

              <v-card-text class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <v-row v-else>
                  <v-col md="6">
                    <v-card
                      class="rounded-lg pa-4"
                      color="grey lighten-5"
                      elevation="0"
                    >
                      <div class="d-flex flex-column align-left">
                        <v-switch
                          v-model="personalInfo.enforce_geofence"
                          inset
                          :true-value="1"
                          :false-value="0"
                          color="cyan"
                          hide-details
                          label="Geo-Fencing Enforcement on Visit Start"
                          class="mt-0 mr-8"
                        ></v-switch>
                      </div>
                    </v-card>
                    <v-card
                      style="border: 1px solid rgb(165 243 252) !important"
                      v-if="personalInfo.enforce_geofence"
                      class="rounded-lg pa-4 mt-3"
                      color="rgb(236 254 255)"
                      elevation="0"
                    >
                      <table width="100%">
                        <tr>
                          <td valign="center">
                            <label
                              class="mb-0 font-size-13 font-weight-medium"
                              for="geo-fencing-radius"
                            >
                              <!-- Geo-Fencing Radius
                                  (in
                                  meters) -->
                              Radius (meters):
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              id="geo-fencing-radius"
                              v-model="personalInfo.radius_geofence"
                              type="number"
                              v-mask="'####'"
                              dense
                              hide-details
                              color="cyan"
                              filled
                              label="Geo-Fencing Radius (in meters)"
                              solo
                              suffix="meters"
                              flat
                            />
                          </td>
                          <!-- <td valign="center">
                                <div class="font-size-14 font-weight-medium">Recommended: 50-500m</div>
                              </td> -->
                        </tr>
                      </table>
                    </v-card>
                  </v-col>
                  <v-col md="6">
                    <v-card
                      class="rounded-lg pa-4"
                      color="grey lighten-5"
                      elevation="0"
                    >
                      <div class="d-flex flex-column align-left">
                        <v-switch
                          v-model="personalInfo.enforce_close_geofence"
                          inset
                          :true-value="1"
                          :false-value="0"
                          color="cyan"
                          hide-details
                          label="Geo-Fencing Enforcement on Visit Stop/Close"
                          class="mt-0 mr-8"
                        ></v-switch>
                      </div>
                    </v-card>
                    <v-card
                      style="border: 1px solid rgb(165 243 252) !important"
                      v-if="personalInfo.enforce_close_geofence"
                      class="rounded-lg pa-4 mt-3"
                      color="rgb(236 254 255)"
                      elevation="0"
                    >
                      <table width="100%">
                        <tr>
                          <td valign="center">
                            <label
                              class="mb-0 font-size-13 font-weight-medium"
                              for="geo-fencing-radius"
                            >
                              Radius (meters):
                              <!-- Geo-Fencing
                                  Radius
                                  (in
                                  meters) -->
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              id="geo-fencing-radius"
                              v-model="personalInfo.radius_close_geofence"
                              v-mask="'####'"
                              dense
                              hide-details
                              color="cyan"
                              filled
                              label="Geo-Fencing Radius (in meters)"
                              solo
                              suffix="meters"
                              flat
                            />
                          </td>
                          <!-- <td valign="center">
                                <div class="font-size-14 font-weight-medium">Recommended: 50-500m</div>
                              </td> -->
                        </tr>
                      </table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <!-- <v-col
                md="12"
                class="py-4"
                v-if="personalInfo.allow_leave == 1 && leaveTypes.length"
              >
                <table width="100%">
                  <tbody>
                    <tr v-for="(row, index) in leaveTypes" :key="index">
                      <td
                        class="font-size-16 font-weight-600 px-2 py-4"
                        valign="middle"
                      >
                        {{ row.title }}
                      </td>
                      <td class="py-2">
                        <v-text-field
                          v-model.trim="personalInfo.engineerLeaves[row.value]"
                          v-mask="'###'"
                          dense
                          hide-details
                          filled
                          :label="row.title"
                          solo
                          flat
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col> -->
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="custom-sidebar-container white lighten-3 text-center"
        cols="12"
        md="3"
        sm="3"
      >
        <div class="text-center">
          <template v-if="updateEngineer && pageLoading">
            <v-skeleton-loader
              class="custom-skeleton custom-avatar-100px"
              type="avatar"
            >
            </v-skeleton-loader>
          </template>
          <template v-else>
            <v-progress-circular
              indeterminate
              :size="150"
              :width="10"
              color="cyan"
              v-if="primaryLoader"
            ></v-progress-circular>
            <v-img
              v-else
              :lazy-src="$defaultProfileImage"
              :src="getProfileImage ? getProfileImage : $defaultProfileImage"
              max-height="200"
              max-width="200"
              height="200px"
              width="200px"
              class="custom-grey-border custom-border-radius-50 mx-auto"
            >
            </v-img>
          </template>
        </div>
        <div class="py-5 text-center">
          <template v-if="updateEngineer && pageLoading">
            <v-skeleton-loader
              class="mx-4 custom-skeleton small-skeleton-action-button"
              type="button"
            >
            </v-skeleton-loader>
          </template>
          <v-btn
            v-else
            class="mx-4 custom-bold-button"
            outlined
            small
            :disabled="primaryLoader"
            :loading="primaryLoader"
            v-on:click="selectImage"
            color="cyan"
          >
            <template v-if="personalInfo.profile_image">Change Image</template>
            <template v-else>Upload Image</template>
          </v-btn>
          <div class="d-none">
            <v-file-input
              v-model.trim="rawImage"
              ref="uploadImage"
              :rules="imageRules"
              accept="image/png, image/jpeg, image/bmp"
            ></v-file-input>
          </div>
        </div>
        <template v-if="false">
          <template v-for="(fieldInfo, indx) in fieldDescriptions">
            <div
              v-if="fieldInfo.field == currentActiveField"
              :key="indx"
              class="help-sidebar"
            >
              <div class="help-sidebar-header">
                <h3 v-if="fieldInfo.title" class="section-header-title">
                  {{ fieldInfo.title }}
                </h3>
              </div>
              <p v-if="fieldInfo.description" class="help-sidebar-description">
                {{ fieldInfo.description }}
              </p>
              <h5 v-if="fieldInfo.footer" class="help-sidebar-footer-title">
                {{ fieldInfo.footer }}
              </h5>
              <p
                v-if="fieldInfo.footer_content"
                class="help-sidebar-footer-text"
              >
                {{ fieldInfo.footer_content }}
              </p>
            </div>
          </template>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: 100%;
}
.v-input input {
  max-height: 30px;
}
.small-chip-autocomplete .v-chip {
  font-size: 11px !important;
  height: 24px !important;
  padding: 0 6px !important;
}

.small-chip-autocomplete .v-select__selections {
  min-height: 40px !important;
  max-height: 80px !important;
  align-items: flex-start !important;
}
</style>
<script>
import ManageEdesignation from "@/view/pages/partials/Manage-Edesignation.vue";
// import ManageDepartment from "@/view/pages/partials/Manage-Department.vue";
import ManageMotorSettings from "@/view/pages/partials/Manage-Motor-Settings.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { EngineerEventBus } from "@/core/lib/engineer/engineer.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import { GET } from "@/core/services/store/request.module";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import DatePicker from "@/view/components/QDatePicker.vue";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "personal-info",
  mixins: [ValidationMixin, CommonMixin, FileManagerMixin],
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    updateEngineer: {
      type: Boolean,
      default: false,
    },
    engineer: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      allowZones: [],
      engineerId: 0,
      zoneList: [],
      engineerSkills: [],
      manageBrandDialog: false,
      manageSbuDialog: false,
      sbuList: [],
      engineerDesignations: [],
      e_designation: [],
      engineerDepartments: [],
      getCustomers: [],
      e_department: [],
      manageDepartmentDialog: false,
      leaveTypes: [],
      timeoutLimit: 100,
      roles: [],
      months: [
        { value: 1, text: "1 (Month)" },
        { value: 2, text: "2 (Month)" },
        { value: 3, text: "3 (Month)" },
        { value: 4, text: "4 (Month)" },
        { value: 5, text: "5 (Month)" },
        { value: 6, text: "6 (Month)" },
        { value: 7, text: "7 (Month)" },
        { value: 8, text: "8 (Month)" },
        { value: 9, text: "9 (Month)" },
        { value: 10, text: "10 (Month)" },
        { value: 11, text: "11 (Month)" },
        { value: 12, text: "12 (Month)" },
      ],
      shifts: [
        { value: 1, text: "Day Shift" },
        { value: 2, text: "Night Shift" },
      ],
      types: [{ value: "month", text: "Month" }],
      timeout: null,
      personalInfo: {
        profile_image: null,
        probation_start: null,
        probation_end: null,
        probation_month_number: null,
        probation_type: "month",
        shift: null,
        is_team: false,
        ot_15_date: null,
        ot_2_date: null,
        title: "mr",
        first_name: null,
        last_name: null,
        display_name: null,
        designation: 0,
        department: 0,
        primary_email: null,
        primary_phone: null,
        engineerLeaves: {},
        // adding new columns
        iu_no: null,
        // wp_expired_date: null,
        // fin_no: null,
        vehicle_no: null,
        employee_code: null,
        enforce_geofence: 0,
        radius_geofence: 0,
        enforce_close_geofence: 0,
        radius_close_geofence: 0,
        skills: [],
        leave: null,
        can_login: 1,
        is_tracking_enabled: 0,
        email_notification: 1,
        allow_leave: 0,
        is_driver: 0,
        ot_eligible: 1,
        role: 0,
        zone_territory: [],
        retention_period: null,
        deletion_period: null,
        period: "Days",
        force_password_change: 1,
        default_retention_period: 1,
        automatic_deletion_period: true,
      },
      rawImage: null,
      fieldDescriptions: [],
      customers: [],
      loadingCustomers: false,
      searchCustomer: "",
    };
  },
  watch: {
    "personalInfo.first_name"() {
      this.personalInfo.display_name =
        (this.personalInfo.first_name || "") +
        " " +
        (this.personalInfo.last_name || "");
    },
    "personalInfo.last_name"() {
      this.personalInfo.display_name =
        (this.personalInfo.first_name || "") +
        " " +
        (this.personalInfo.last_name || "");
    },
    rawImage(param) {
      const _this = this;
      _this.uploadAttachment(param).then((response) => {
        _this.personalInfo.profile_image = _this.lodash.head(response);
      });
    },
    personalInfo: {
      deep: true,
      immediate: true,
      handler(param) {
        const _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          EngineerEventBus.$emit("update:personal-info", param);
        }, _this.timeoutLimit);
      },
    },
    engineer() {
      this.setPersonalInfo();
    },
  },
  methods: {
    getLabel() {
      return `Credentials to be sent to user via email ${
        this.personalInfo?.primary_email
          ? this.personalInfo?.primary_email
          : ".....@gmail.com"
      }`;
    },
    setProbationTime() {
      if (this.personalInfo && this.personalInfo.probation_start) {
        const startDate = moment(
          this.personalInfo.probation_start,
          "YYYY-MM-DD"
        );
        let date = startDate.clone();

        if (
          this.personalInfo.probation_month_number &&
          this.personalInfo.probation_type
        ) {
          date.add(this.personalInfo.probation_month_number, "M");

          const isOneMonth = this.personalInfo.probation_month_number == 1;
          const isJanuary = startDate.month() == 0;
          const startDay = startDate.date();
          const isEndOfJan = startDay >= 29;
          const isLeapYear = startDate.isLeapYear();

          const skipSubtract =
            isOneMonth &&
            isJanuary &&
            isEndOfJan &&
            !(isLeapYear && startDay == 29);

          if (!skipSubtract) {
            date.subtract(1, "days");
          }
        }

        this.personalInfo.probation_end = date.format("YYYY-MM-DD");
      }
    },
    setWpExipryDate() {
      if (this.personalInfo && this.personalInfo.wp_expiry_date) {
        let date = moment(this.personalInfo.wp_expiry_date, "DD-MM-YYYY");

        this.personalInfo.wp_expiry_date = date.format("DD-MM-YYYY");
      }
    },
    Designationdata() {
      this.manageBrandDialog = true;
      this.getOptions();
    },
    Departmentdata() {
      this.manageSbuDialog = true;
      this.getSbuList();
    },
    getSbuList() {
      const _this = this;
      this.$store.dispatch(GET, { url: "setting/sbu" }).then(({ data }) => {
        _this.sbuList = data.filter((item) => item.activated);
        _this.engineerDepartments = _this.lodash.map(
          _this.sbuList,
          function (row) {
            return {
              text: row.text,
              value: row.value || row.id,
            };
          }
        );
      });
    },
    getRolesNew() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "user-role-new" })
        .then(({ data }) => {
          _this.roles = data;
          // console.log(_this.roles, "hello");
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "engineer/options",
        })
        .then(({ data }) => {
          this.zoneList = data?.active_zones;
          this.$emit("barcode", data.barcode);
          _this.engineerDesignations = this.lodash.map(
            data.engineer_designation,
            function (row) {
              return {
                text: row.text,
                value: row.id,
              };
            }
          );
          _this.engineerDepartments = this.lodash.map(
            data.engineer_departments,
            function (row) {
              return {
                text: row.text,
                value: row.id,
              };
            }
          );
          _this.sbuList = data.engineer_departments;

          _this.getCustomers = this.lodash.map(data.customers, function (row) {
            return {
              display_name: row.display_name,
              id: row.id,
            };
          });

          _this.engineerSkills = this.lodash.map(data.skills, function (row) {
            return {
              title: row.value,
              value: row.value.toLowerCase(),
            };
          });
          _this.leaveTypes = this.lodash.map(data.leave_types, function (row) {
            return {
              title: row.value,
              value: row.id,
            };
          });

          _this.allowZones = data?.allow_zones;
          /*  EngineerEventBus.$emit("update:option:data", data); */
          /*  const _this = this;
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function () {
            EngineerEventBus.$emit("update:option:data", data);
          }, _this.timeoutLimit); */
          /*   _this.skillCertificate = this.lodash.map(data.skillCertificate, function (row) {
            return {
              title: row.text,
              value: row.value.toLowerCase(),
            };
          });
          _this.licenseCertificate = this.lodash.map(data.licenseCertificate, function (row) {
            return {
              title: row.text,
              value: row.value.toLowerCase(),
            };
          }); */
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },

    setPersonalInfo() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.engineer) === false) {
        _this.personalInfo.profile_image = _this.engineer.profile_logo;
        _this.personalInfo.title = _this.engineer.title;
        _this.personalInfo.first_name = _this.engineer.first_name;
        _this.personalInfo.last_name = _this.engineer.last_name;
        _this.personalInfo.role = _this.engineer.role.id;
        _this.personalInfo.display_name = _this.engineer.display_name;
        _this.personalInfo.retention_period = _this.engineer.retention_period;
        _this.personalInfo.deletion_period = _this.engineer.deletion_period;
        if (_this.engineer.designation && _this.engineer.designation.id) {
          _this.personalInfo.designation = _this.engineer.designation.id;
        }

        _this.personalInfo.skills = _this.engineer.skills;

        _this.personalInfo.iu_no = _this.engineer.iu_no;
        _this.personalInfo.employee_code = _this.engineer.employee_code;

        if (_this.engineer.department && _this.engineer.department.id) {
          _this.personalInfo.department = _this.engineer.department.id;
        }
        _this.personalInfo.wp_expiry_date = _this.engineer.wp_expiry_date;
        _this.personalInfo.wp_expiry_date = _this.engineer.wp_expiry_date;

        // _this.personalInfo.wp_expired_date = _this.engineer.wp_expired_date;
        // _this.personalInfo.fin_no = _this.engineer.fin_no;
        _this.personalInfo.vehicle_no = _this.engineer.vehicle_no;
        _this.personalInfo.is_tracking_enabled =
          _this.engineer.is_tracking_enabled;

        _this.personalInfo.primary_email = _this.engineer.primary_email;
        _this.personalInfo.probation_start = _this.engineer.probation_start;
        _this.personalInfo.probation_end = _this.engineer.probation_end;
        _this.personalInfo.probation_type = _this.engineer.probation_type;
        _this.personalInfo.probation_month_number =
          _this.engineer.probation_month_number;
        _this.personalInfo.shift = _this.engineer.shift;
        _this.personalInfo.is_team =
          _this.engineer.is_team === true ||
          _this.engineer.is_team === 1 ||
          _this.engineer.is_team === "1";
        _this.personalInfo.ot_15_date = _this.engineer.ot_15_date;
        _this.personalInfo.ot_2_date = _this.engineer.ot_2_date;
        _this.personalInfo.primary_phone = _this.engineer.primary_phone;
        _this.personalInfo.leave = _this.engineer.leave;
        _this.personalInfo.can_login = +_this.engineer.can_login;
        _this.personalInfo.email_notification =
          +_this.engineer.email_notification;
        _this.personalInfo.allow_leave = +_this.engineer.allow_leave;

        _this.personalInfo.is_driver = +_this.engineer.is_driver;
        _this.personalInfo.ot_eligible = +_this.engineer.ot_eligible;
        _this.personalInfo.zone_territory = _this.engineer.zone_territory;
        if (_this.engineer.leaves && _this.engineer.leaves.length > 0) {
          for (let i = 0; i < _this.engineer.leaves.length; i++) {
            const { leave, leave_allowed } = _this.engineer.leaves[i];
            _this.personalInfo.engineerLeaves[leave.id] = leave_allowed;
          }
        }
        _this.personalInfo.force_password_change =
          _this.engineer?.force_password_change;
      }
    },
  },
  computed: {
    getProfileImage() {
      return this.lodash.isEmpty(this.personalInfo.profile_image) === false
        ? this.personalInfo.profile_image.file.url
        : null;
    },
  },
  created() {
    this.engineerId = Number(this.$route?.params?.id ?? 0);
  },
  components: {
    PhoneTextField,
    ManageEdesignation,
    // ManageDepartment,
    ManageMotorSettings,
    DatePicker,
  },
  mounted() {
    this.setPersonalInfo();
    this.getOptions();
    this.getRolesNew();
  },
};
</script>
